import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, CardItems} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {formatDateTime} from "../utils/utils";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující historii změn objednávky.
 */
class HistorieZmenPanel extends Component<WithTranslation> {

    static propTypes = {
        objednavkaZmenaList: PropTypes.array.isRequired, // seznam změn objednávky (ObjednavkaZmenaVO)
    };

    render() {
        const {objednavkaZmenaList, t} = this.props;
        return <Card>
            <CardHeader>
                <ActionsRow>
                    <h2>{t('changes_history', {count: objednavkaZmenaList.length})}</h2>
                </ActionsRow>
            </CardHeader>
            {objednavkaZmenaList.length > 0 ?
                <CardItems bordered>
                    {objednavkaZmenaList.map(zmena => <CardBody key={zmena.id}>
                        <Row>
                            <Col xs={3}>{formatDateTime(zmena.datumZmena)}</Col>
                            <Col xs={3}>{zmena.uzivatel}</Col>
                            <Col xs={6}>
                                {zmena.popisZmena.split('\n').map((item, key) =>
                                    <div className="mb-2" key={key}>{item}</div>
                                )}
                            </Col>
                        </Row>
                    </CardBody>)}
                </CardItems>
                : <CardBody><i>{t('no_changes')}</i></CardBody>
            }
        </Card>
    }
}

export default connect()(withTranslation()(HistorieZmenPanel));
